import { createFileRoute } from '@tanstack/react-router';
import { ExamAccessPage } from '@/features/mockExams/guest/ExamAccessPage';
export const Route = createFileRoute('/exam-access')({ component: ExamAccessPage });
